module.exports = __webpack_public_path__ + "img/mezzo1.e172c0e6.png";